export default "__VITE_ASSET__BmmyMCH7__"